import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { Formik } from 'formik';

import { PlanDetailsCard } from '@components/Order/Numbers/Cards';
import { PSTNUpgradeFilter } from '@components/Order/PSTNUpgrade/PSTNUpgradeFilter';
import { PSTNUpgradeTable } from '@components/Order/PSTNUpgrade/PSTNUpgradeTable';
import { numberApi } from '@reducers/number/number';
import { skipToken } from '@reduxjs/toolkit/query';

export const PSTNUpgrade = () => {
  const [searchParams] = useSearchParams();
  const { planInfo } = useSelector((state) => state.plan);
  const country = searchParams.get('country') || '';
  const plan = searchParams.get('plan');
  const isCountrySelected = ![undefined, '', null].includes(country);
  const isPlanSelected = ![undefined, '', null].includes(plan);
  const queryArg =
    isCountrySelected && isPlanSelected ? { country, plan } : skipToken;
  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          country,
          plan: searchParams.get('plan') || '',
          type: searchParams.get('type') || '',
        }}
        onSubmit={() => {}}
      >
        <Form as={Row}>
          <Col md={3}>
            <PSTNUpgradeFilter />
          </Col>
          <Col md={9}>
            <PSTNUpgradeTable
              useData={numberApi.useGetPSTNUpgradeNumbersQuery}
              useDataArgs={queryArg}
            />
          </Col>
        </Form>
      </Formik>
      <Row>
        <Col md={3} />
        <Col md={9}>
          {planInfo.showState.details ? (
            <PlanDetailsCard initialKey="outboundRates" />
          ) : null}
        </Col>
      </Row>
    </>
  );
};
